const MODAL_SUCCESS = "#modal-success";
const MODAL_ERROR = "#modal-error";

const MODAL_SUCCESS_MESSAGES_LIST = "#modal-success ul";
const MODAL_ERROR_MESSAGES_LIST = "#modal-error ul";

const MESSAGE_LIST_ITEM_TEMPLATE = ({message}) => `
    <li>${message}</li>
`;

export default class Alert {

    static buildMessageList(messages) {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }
        let data = [];

        $(messages).each(function (index, message) {
            data.push({
                message: message,
            });
        });

        return data.map(MESSAGE_LIST_ITEM_TEMPLATE).join('');
    }

    static showSuccessMessage(messages) {

        $(MODAL_SUCCESS_MESSAGES_LIST).html(this.buildMessageList(messages));
        $(MODAL_SUCCESS).modal('show');
    }

    static showErrorMessage(messages) {

        $(MODAL_ERROR_MESSAGES_LIST).html(this.buildMessageList(messages));
        $(MODAL_ERROR).modal('show');
    }

    static parseValidationExceptionResponse(response) {

        let data = [];

        Object.keys(response.data.errors).forEach(function (key, index) {
            data.push(
                response.data.errors[key][0],
            );
        });

        return data;
    }

    static success(messages) {
        Alert.showSuccessMessage(messages);
    }

    static error(messages) {
        Alert.showErrorMessage(messages);
    }

    static errorFromResponse(response) {
        Alert.showErrorMessage(Alert.parseValidationExceptionResponse(response));
    }
}
/*const MODAL_SUCCESS = "#modal-success";
const MODAL_ERROR = "#modal-error";

const MODAL_SUCCESS_MESSAGES_LIST = "#modal-success > ul";
const MODAL_ERROR_MESSAGES_LIST = "#modal-error > ul";

const MESSAGE_LIST_ITEM_TEMPLATE = ({message}) => `
    <li>${message}</li>
`;

function buildMessageList(messages) {
    if (!Array.isArray(messages)) {
        messages = [messages];
    }
    let data = [];

    $(messages).each(function (index, message) {
        data.push({
            message: message,
        });
    });

    return data.map(MESSAGE_LIST_ITEM_TEMPLATE).join('');

}

function showSuccessMessage(messages) {

    $(MODAL_SUCCESS).html(buildMessageList(messages));
    $.fancybox.open(MODAL_SUCCESS);
}

function showErrorMessage(messages) {

    $(MODAL_ERROR).html(buildMessageList(messages));
    $.fancybox.open(MODAL_ERROR);
}

/!*GENERATE HTTP REQUEST ERROR MESSAGES LIST*!/
function parseValidationExceptionResponse(response) {

    let data = [];

    Object.keys(response.data.errors).forEach(function (key, index) {
        data.push(
            response.data.errors[key][0],
        );
    });

    return data;
}*/


/*const ERROR_LIST_ITEM_TEMPLATE = ({error}) => `
            <li>${error}</li>
        `;

/!*SHOW ERROR MODAL*!/
function showErrorsDefault(errors) {

    let data = [];

    $(errors).each(function (index, error) {
        data.push({
            error: error,
        });
    });

    let html = data.map(ERROR_LIST_ITEM_TEMPLATE).join('');

    $(ERRORS_DEFAULT_LIST).html(html);
    $.fancybox.open($(ERRORS_DEFAULT_CONTAINER));
}

/!*GENERATE HTTP REQUEST ERROR MESSAGES LIST*!/
function parseValidationExceptionResponse(response) {

    let data = [];

    Object.keys(response.data.errors).forEach(function (key, index) {
        data.push({
            error: response.data.errors[key][0],
        });
    });

    return data.map(ERROR_LIST_ITEM_TEMPLATE).join('');

}*/
